import { render, staticRenderFns } from "./project_dashboard.vue?vue&type=template&id=d5ee76aa&scoped=true&"
import script from "./project_dashboard.vue?vue&type=script&lang=js&"
export * from "./project_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./project_dashboard.vue?vue&type=style&index=0&id=d5ee76aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ee76aa",
  null
  
)

/* custom blocks */
import block0 from "./project_dashboard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports